import { useState, useEffect, useCallback } from "react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import PromoBanner from "@/components/PromoBanner";
import HeroSection from "@/components/HeroSection";
import TrustBadges from "@/components/TrustBadges";
import AboutSection from "@/components/AboutSection";
import ProcessSection from "@/components/ProcessSection";
import ServicesSection from "@/components/ServicesSection";
import PortfolioSection from "@/components/PortfolioSection";
import WhyChooseUsSection from "@/components/WhyChooseUsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import WhatsAppButton from "@/components/WhatsAppButton";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";

function App() {
  const [dark, setDark] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('theme') === 'dark';
    }
    return false;
  });

  const [bannerVisible, setBannerVisible] = useState(false);

  const [bannerHeight, setBannerHeight] = useState(0);
  const bannerRef = useCallback((node) => {
    if (!node) return;
    const ro = new ResizeObserver(([entry]) => {
      setBannerHeight(entry.contentRect.height);
    });
    ro.observe(node);
  }, []);

  const closeBanner = () => {
    setBannerVisible(false);
    setBannerHeight(0);
    sessionStorage.setItem('promoBannerClosed', '1');
  };

  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [dark]);

  return (
    <div className="App" data-testid="app-root">
      <PromoBanner visible={bannerVisible} onClose={closeBanner} measureRef={bannerRef} />
      <div style={{ paddingTop: bannerVisible ? bannerHeight : 0, transition: 'padding-top 0.4s ease' }}>
        <Navbar dark={dark} setDark={setDark} bannerVisible={bannerVisible} bannerHeight={bannerHeight} />
        <HeroSection />
        <TrustBadges />
        <AboutSection />
        <ProcessSection />
        <ServicesSection />
        <PortfolioSection />
        <WhyChooseUsSection />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
        <Footer />
        <WhatsAppButton />
        <CookieConsent />
      </div>
    </div>
  );
}

export default App;
